export function buildAppContextHeaders(getCookie: (name: string) => string | undefined): {
  platform?: string;
  osType?: string;
  appVersion?: string;
  appOpenSource?: string;
} {
  const platform = getCookie('platform');
  const osType = getCookie('hzc_os_type');
  const appVersion = getCookie('hzc_app_version_code');
  const appOpenSource = getCookie('hzc_app_open_source');

  return {
    ...(platform ? { platform } : {}),
    ...(osType ? { osType } : {}),
    ...(appVersion ? { appVersion } : {}),
    ...(appOpenSource ? { appOpenSource } : {}),
  };
}
